export const MODALITY_LABEL = {
  macro: "Macroscopie",
  radio: "Radiologie",
  histo: "Histologie",
};

export const MODALITY_ORDER = ["macro", "radio", "histo"];

export const getAnnotationKey = (item) => {
  if (!item || !item.type) return null;
  if (item.type === "macro") return "macro";
  if (item.type === "histo") return "histo";
  if (item.type === "radio") {
    // Radio annotations are keyed by the asset name (e.g. "radio:series1").
    const name = item.content?.name ?? item.content?.seriesName;
    return name ? `radio:${name}` : null;
  }
  return null;
};

export const getModalityFromKey = (key) => {
  if (!key) return null;
  if (key === "macro") return "macro";
  if (key === "histo") return "histo";
  if (key.startsWith("radio:")) return "radio";
  return null;
};

export const getSubLabelFromKey = (key) => {
  if (!key) return "";
  if (key.startsWith("radio:series1")) return "Phase portale";
  if (key.startsWith("radio:series2")) return "Non injectée";
  return "";
};
